/**
 * Curated Unsplash hero images for the 16 FarmersPulse feature guides.
 *
 * Each URL is size-capped (`&w=1600&q=70&auto=format`) so page weight
 * remains modest; they render as the card cover on `/guides` and the
 * hero on `/guides/:slug` (client-side; GuidePage can pick them up).
 */
export const GUIDE_COVERS = {
  "farmers-pulse-today":  "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1600&q=70&auto=format&fit=crop",
  "weather-today":        "https://images.unsplash.com/photo-1561484930-998b6a7b22e8?w=1600&q=70&auto=format&fit=crop",
  "rainfall":             "https://images.unsplash.com/photo-1519692933481-e162a57d6721?w=1600&q=70&auto=format&fit=crop",
  "irrigation":           "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1600&q=70&auto=format&fit=crop",
  "growing-conditions":   "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?w=1600&q=70&auto=format&fit=crop",
  "farm-alerts":          "https://images.unsplash.com/photo-1516905090077-05e91a5eaefc?w=1600&q=70&auto=format&fit=crop",
  "what-to-plant":        "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1600&q=70&auto=format&fit=crop",
  "what-to-harvest":      "https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=1600&q=70&auto=format&fit=crop",
  "pest-disease-alerts":  "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=1600&q=70&auto=format&fit=crop",
  "nearby-farmer-reports":"https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=70&auto=format&fit=crop",
  "my-farm":              "https://images.unsplash.com/photo-1444858291040-58f756a3bdd6?w=1600&q=70&auto=format&fit=crop",
  "farm-diary":           "https://images.unsplash.com/photo-1517495306984-f84210f9daa8?w=1600&q=70&auto=format&fit=crop",
  "farm-calendar":        "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=1600&q=70&auto=format&fit=crop",
  "agricultural-news":    "https://images.unsplash.com/photo-1495020689067-958852a7765e?w=1600&q=70&auto=format&fit=crop",
  "ask-farmers-pulse":    "https://images.unsplash.com/photo-1580982327559-c1202864eb05?w=1600&q=70&auto=format&fit=crop",
  "global-farming":       "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=1600&q=70&auto=format&fit=crop",
};

export function coverFor(slug) {
  return GUIDE_COVERS[slug] || null;
}
